export const blockScrollOnBody = () => {
  document.body.style.overflowX = 'hidden'
  document.body.style.overflowY = 'hidden'
}

export const releaseScrollOnBody = () => {
  document.body.style.overflowX = 'hidden'
  document.body.style.overflowY = 'scroll'
}
